import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Optional, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIImageControlComponent),
            multi: true
        }
    ],
    selector: "fui-image-control",
    styleUrls: ["./image-control.component.scss"],
    templateUrl: "./image-control.component.html"
})
export class FUIImageControlComponent extends FUIAbstractControl {
    @Input() maxImageSize: number;
    @Input() allowSvg: boolean = false;
    @Input() showImage: boolean = true;
    @Input() showOpacitySlider: boolean = false;
    @Input() placeholderImage: string;
    @Output() imageOpacityChange: EventEmitter<number> = new EventEmitter<number>();

    private _imageOpacity: number = 1.0;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }

    get imageOpacity(): number {
        return this._imageOpacity;
    }

    @Input()
    set imageOpacity(imageOpacity: number) {
        if (!this.valueEqual(imageOpacity, this._imageOpacity)) {
            this._imageOpacity = imageOpacity;
            this.imageOpacityChange.emit(imageOpacity);
        }
    }
}
